import { render } from "./WithdrawalsDetail.vue?vue&type=template&id=030264b5&scoped=true&ts=true"
import script from "./WithdrawalsDetail.vue?vue&type=script&lang=ts"
export * from "./WithdrawalsDetail.vue?vue&type=script&lang=ts"

import "./WithdrawalsDetail.vue?vue&type=style&index=0&id=030264b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030264b5"]])

export default __exports__